import { gql } from '@apollo/client';
import { OrderType } from '../../../../../graphql/types/OrderType';

// 批量设置Next Action
export const BATCH_SET_NEXT_ACTION = gql`
    mutation BatchSetNextAction($orderIds: [Long!]!, $actionName: String!) {
        batchSetNextAction(orderIds: $orderIds, actionName: $actionName) {
            id
            trackingNumber
            nextAction
            exceptionReasonCode
            markExceptionAt
            overallStatus
            isAbnormal
        }
    }
`;

export interface BatchSetNextActionResponse {
    batchSetNextAction: OrderType[];
}

export interface BatchSetNextActionVariables {
    orderIds: number[];
    actionName: string;
} 